import React from 'react';

import { Area } from '@app/objects/Area';

const MailingAddress: React.FC<{ area: Area & any | undefined}> = ({ area }) => {
	return (
		!area?.isExternal ? (
			<div className="mailing-address" style={{ marginTop: '64px' }}>
				<h4 className="middle-text__title">Mailing address</h4>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>Lap of Love</p>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>17804 US Highway 41 North</p>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>Lutz, Florida 33549</p>
			</div>
		) : (
			<div className="mailing-address" style={{ marginTop: '64px' }}>
				<h4 className="middle-text__title">Mailing address</h4>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>
					Lap of Love
				</p>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>
					{area.street ? area.street : null}
					{' '}
					{area.street2 ? area.street2 : null}
				</p>
				<p className="middle-text__text" style={{ marginBottom: 0 }}>
					{area.city ? `${area.city},` : null}
					{' '}
					{area.state}
					{' '}
					{area.zipCode ? area.zipCode : null}
				</p>
			</div>
		)
	);
};

export default MailingAddress;
